var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDesktopMedical = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 1.5C1.34315 1.5 0 2.84315 0 4.5V15C0 16.6569 1.34315 18 3 18H21C22.6569 18 24 16.6569 24 15V4.5C24 2.84315 22.6569 1.5 21 1.5H3ZM3 3C2.17157 3 1.5 3.67157 1.5 4.5V15C1.5 15.8284 2.17157 16.5 3 16.5H21C21.8284 16.5 22.5 15.8284 22.5 15V4.5C22.5 3.67157 21.8284 3 21 3H3Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 18H10.5V22.5H9V18Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 18H15V22.5H13.5V18Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 23.25C4.5 22.8358 4.83579 22.5 5.25 22.5H18.75C19.1642 22.5 19.5 22.8358 19.5 23.25C19.5 23.6642 19.1642 24 18.75 24H5.25C4.83579 24 4.5 23.6642 4.5 23.25Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.25 5.25C14.25 4.83579 13.9142 4.5 13.5 4.5H10.5C10.0858 4.5 9.75 4.83579 9.75 5.25V7.5H7.5C7.08579 7.5 6.75 7.83579 6.75 8.25V11.25C6.75 11.6642 7.08579 12 7.5 12H9.75V14.25C9.75 14.6642 10.0858 15 10.5 15H13.5C13.9142 15 14.25 14.6642 14.25 14.25V12H16.5C16.9142 12 17.25 11.6642 17.25 11.25V8.25C17.25 7.83579 16.9142 7.5 16.5 7.5H14.25V5.25ZM12.75 6H11.25V9H8.25V10.5H11.25V13.5H12.75V10.5H15.75V9H12.75V6Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDesktopMedical);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/desktop-medical.2fc7df8bd56fb53d35f1194f085eb18f.svg";